import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { ModalOptions } from '../types';

export interface ListModalContextState {
  showListModalOptions: (options: ModalOptions) => void;
  listModalOptions?: ModalOptions;
  closeModal: () => void;
}

export const ListModalContext = createContext<ListModalContextState>({
  showListModalOptions: noop,
  closeModal: noop,
});

export const useListModalContext = () => useContext(ListModalContext);
